"use strict";

exports.__esModule = true;
exports["default"] = Invention20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Invention20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 20c.8 0 1.6-.4 1.7-1.7H8.3c0 1.3.9 1.7 1.7 1.7zM10 0C6.7 0 4 2.8 4 6.2c0 1 .2 1.8.5 2.7l2.9 5.9h5.1l2.7-5.6c.5-.9.7-2 .7-3.1C16 2.7 13.3 0 10 0zm4.3 7h-.9l-1.7 2.6L10 6.1 8.3 9.6 6.6 7h-.9v-.9h1.7l.9.9L10 3.5 11.7 7l.9-.9h1.7V7zM11.7 15.7H8.3c-.5 0-.9.4-.9.9s.4.9.9.9h3.4c.5 0 .9-.4.9-.9 0-.6-.4-.9-.9-.9z"
  }));
}